import { Component, Inject, Injector, OnInit, ViewChild } from '@angular/core';
import { TabDetailPanelParameters, TabDetailParameterName } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { WidgetSettingsToken } from '@common-modules/dynamic-layout/dynamic-layout-external-settings';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { BaseWidgetComponent } from '@common-modules/shared/component/base-widget.component';
import { GridSetting } from '@common-modules/shared/constants/grid.constants';
import { GridSettingsService } from '@common-modules/shared/core/grid/grid-settings.service';
import { DataBindingFilters } from '@common-modules/shared/filters/component-filters/data-binding-filters';
import { GenericGridComponent } from '@common-modules/wlm-grid/generic-grid/generic-grid.component';

const COMPONENT_SELECTOR = 'ct-measure-point-configuration';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './measure-point-configuration.component.html',
  styleUrl: './measure-point-configuration.component.scss',
  standalone: false
})
export class MeasurePointConfigurationComponent extends BaseWidgetComponent implements OnInit {

  @ViewChild(GenericGridComponent) public genericGrid: GenericGridComponent;

  gridSettings: GridSetting;
  filters: DataBindingFilters;
  additionalFilters: Map<string, string>;
  private readonly _gridName = 'PointConfigurations';

  private _pointId: string;
  public get pointId(): string {
    return this._pointId;
  }
  public set pointId(v: string) {
    this._pointId = v;
    this.init();
  }

  modelId: string;
  modelVersionId: string;

  constructor(
    readonly injector: Injector,
    @Inject(WidgetSettingsToken) readonly widgetSettings: StateWidgetSettings,
    private _gridSettingService: GridSettingsService
  ) {
    super(injector, widgetSettings);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this._gridSettingService.getGridSettingsByName(this._gridName).subscribe({
      next: (gridSettings) => {
        if (gridSettings) {
          this.gridSettings = gridSettings;
        }
      },
    });
  }

  mapInitParameters(parameters: TabDetailPanelParameters) {
    this.modelId = parameters.parameters.get(TabDetailParameterName.modelId);
    this.modelVersionId = parameters.parameters.get(TabDetailParameterName.modelVersionId);
    this.pointId = parameters.parameters.get(TabDetailParameterName.signalId);
  }

  init(): void {
    this.setDataBindingFilter();
  }

  private setDataBindingFilter() {
    if (!this.pointId)
      return;

    const additionalFilters = new Map<string, string>();
    const auxFilter = new DataBindingFilters();

    if (this.pointId) {
      additionalFilters.set(TabDetailParameterName.pointId, this.pointId);
    }

    if (this.modelId) {
      additionalFilters.set(TabDetailParameterName.modelId, this.modelId);
    }

    if (this.modelVersionId) {
      additionalFilters.set(TabDetailParameterName.modelVersionId, this.modelVersionId);
    }

    this.filters = auxFilter;
    this.additionalFilters = additionalFilters;

    this.genericGrid?.reloadGrid();
  }

  get componentName() {
    return 'MeasurePointConfigurationComponent';
  }
}
